import {authRequest} from './index.js'


export async function get_term(term_id){
  let data
  await authRequest.get(
    'terms/' + term_id
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function get_terms(term_taxonomy, include = { exist: false, name: '' }){
  let data  
  let url = 'term-taxonomy/' + term_taxonomy
  if (include.exist){
    url = 'term-taxonomy/' + term_taxonomy 
          + '?include=term_relationship'
          + '&object_type=' + include.name
  }
  await authRequest.get(
    url
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function create_term(term){
  let data
  await authRequest.post(
    '/terms',
    { term },
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function delete_term(term_id){
  let data
  await authRequest.delete(
    '/terms/' + term_id
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function update_term(term_id, term){
  let data
  await authRequest.patch(
    '/terms/' + term_id,
    { term },
    { headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function create_term_relationship(term){
  let data
  await authRequest.post(
    '/terms-relationship',
    { term },
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}